import React from 'react';
import type { LessonPart } from '../../hooks/useLessonApi';
import type { RunMode } from '../../turncard/viewModel';
import { INTERFACE_TEXT } from '../../constants/interfaceText';
import { unlockPromptPlayback } from '../../speech';
import styles from './IntroCard.module.css';

interface IntroCardProps {
  contextName: string;
  /** Lesson: the scene text; check-in: the intro text, shown as given. */
  sceneText: string;
  parts: LessonPart[];
  mode: RunMode;
  /** The run has loaded; Start waits for it. */
  ready: boolean;
  onStart: () => void;
  onLeave: () => void;
}

export const IntroCard: React.FC<IntroCardProps> = ({
  contextName,
  sceneText,
  parts,
  mode,
  ready,
  onStart,
  onLeave,
}) => {
  const checkin = mode === 'checkin';
  const handleStart = (): void => {
    // The tap lets later check-in lines autoplay; a lesson plays nothing yet.
    if (checkin) unlockPromptPlayback();
    onStart();
  };
  return (
    <div className={styles.intro} data-testid="intro-card">
      <span className={styles.eyebrow}>
        {checkin
          ? INTERFACE_TEXT.tsEyebrowCheckin
          : INTERFACE_TEXT.tsEyebrowLesson}
      </span>
      <h2 className={styles.heading}>{contextName}</h2>
      {sceneText && <p className={styles.scene}>{sceneText}</p>}
      {!checkin && parts.length > 0 && (
        <section aria-labelledby="learn-heading">
          <h3 id="learn-heading" className={styles.learnHeading}>
            {INTERFACE_TEXT.tsLearnHeading}
          </h3>
          <ul className={styles.learn}>
            {parts.map((p) => (
              <li key={p.id}>{p.label}</li>
            ))}
          </ul>
        </section>
      )}
      {mode === 'lesson' && (
        <p className={styles.hint}>{INTERFACE_TEXT.tsSoundOnHint}</p>
      )}
      <button
        type="button"
        className={styles.cta}
        onClick={handleStart}
        data-shortcut="start"
        aria-keyshortcuts="Space"
        disabled={!ready}
      >
        {ready ? INTERFACE_TEXT.tsStart : INTERFACE_TEXT.tsGettingReady}
      </button>
      <button type="button" className={styles.alt} onClick={onLeave}>
        {INTERFACE_TEXT.tsBackToToday}
      </button>
    </div>
  );
};

export default IntroCard;
